
interface NavbarProps {
  isScrolled: boolean;
}

export default function Navbar({ isScrolled }: NavbarProps) {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-white/95 backdrop-blur-sm shadow-sm'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-20">
          <a href="/" className="flex items-center gap-3">
            <img
              src="https://static.readdy.ai/image/5e5e0a5518213db53ed2e7d68521f761/62cb70853685ca02083f2cf2f9848005.jpeg"
              alt="PACED Coaching Logo"
              className="h-12 w-12 object-cover rounded-full"
            />
            <span className="text-xl font-bold text-gray-900">
              PACED Coaching
            </span>
          </a>

          <div className="hidden md:flex items-center gap-8">
            <button
              onClick={() => scrollToSection('features')}
              className="text-sm font-medium text-gray-700 transition-colors hover:text-[#E8744F] whitespace-nowrap cursor-pointer"
            >
              Features
            </button>
            <button
              onClick={() => scrollToSection('who-its-for')}
              className="text-sm font-medium text-gray-700 transition-colors hover:text-[#E8744F] whitespace-nowrap cursor-pointer"
            >
              Who It's For
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="text-sm font-medium text-gray-700 transition-colors hover:text-[#E8744F] whitespace-nowrap cursor-pointer"
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('pricing')}
              className="text-sm font-medium text-gray-700 transition-colors hover:text-[#E8744F] whitespace-nowrap cursor-pointer"
            >
              Pricing
            </button>
            <a
              href="mailto:pacedcoaching@gmail.com?subject=Summer XC Training"
              target="_blank"
              rel="noopener noreferrer"
              className="px-6 py-2.5 bg-[#E8744F] text-white text-sm font-semibold rounded-full hover:bg-[#d66640] transition-colors whitespace-nowrap cursor-pointer"
            >
              Email Us!
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}
